import(/* webpackMode: "eager", webpackExports: ["QuickAccessHandler"] */ "/opt/build/repo/apps/my/components/quick-access-handler.tsx");
